import { Component, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { ToastService } from '../../../Util/Toast/toast.service';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-approval-tracking',
  standalone: true,
  imports: [CommonModule, DataTablesModule],
  templateUrl: './approval-tracking.component.html',
  styleUrl: './approval-tracking.component.scss'
})
export class ApprovalTrackingComponent {
  isDisabled: boolean = false;
  @Input() Detail = {
    ModuleMasterId: 0,
    EmpMasterId: 0,
    EmpMappingId: 0,
    TransactionId: 0,
    UserImage: null,
    EmployeeName: null as any,
    EmpCode: null,
    DesignationName: null,
  }

  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private toast: ToastService,
    private activeModal: NgbActiveModal,
    private approvalMatrix: ApprovalMatrixService,
    protected common: CommonService
  ) { 
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ApprovalMatrixRequestGetTracking();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ApprovalMatrixRequestGetTracking() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.Detail.ModuleMasterId, FromDate: '', ToDate: '', EmpMasterId: this.Detail.EmpMasterId,EmpMappingId:this.Detail.EmpMappingId, SelectType1: 'ApprovalStatus', SelectType: '', TransactionId: this.Detail.TransactionId }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  close() {
    this.activeModal.close();
  }
}
